"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CornerUpLeft = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "corner-up-left" },
            react_1.default.createElement("path", { id: "Icon", d: "M8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071C10.0976 14.3166 10.0976 13.6834 9.70711 13.2929L8.29289 14.7071ZM4 9L3.29289 8.29289C2.90237 8.68342 2.90237 9.31658 3.29289 9.70711L4 9ZM9.70711 4.70711C10.0976 4.31658 10.0976 3.68342 9.70711 3.29289C9.31658 2.90237 8.68342 2.90237 8.29289 3.29289L9.70711 4.70711ZM19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20H19ZM19.346 12.2761L18.455 12.73V12.73L19.346 12.2761ZM16.7239 9.65396L16.27 10.545H16.27L16.7239 9.65396ZM9.70711 13.2929L4.70711 8.29289L3.29289 9.70711L8.29289 14.7071L9.70711 13.2929ZM4.70711 9.70711L9.70711 4.70711L8.29289 3.29289L3.29289 8.29289L4.70711 9.70711ZM21 20V18.6H19V20H21ZM10.4 8H4V10H10.4V8ZM21 18.6C21 16.9363 21.0008 15.6285 20.9149 14.5778C20.8281 13.5154 20.6478 12.6283 20.237 11.8221L18.455 12.73C18.6982 13.2073 18.8449 13.802 18.9216 14.7406C18.9992 15.691 19 16.9033 19 18.6H21ZM10.4 10C12.0967 10 13.309 10.0008 14.2594 10.0784C15.198 10.1551 15.7927 10.3018 16.27 10.545L17.1779 8.76295C16.3717 8.35217 15.4846 8.17186 14.4222 8.08507C13.3715 7.99922 12.0637 8 10.4 8V10ZM20.237 11.8221C19.5659 10.5049 18.4951 9.43407 17.1779 8.76295L16.27 10.545C17.2108 11.0243 17.9757 11.7892 18.455 12.73L20.237 11.8221Z" }))));
};
exports.default = CornerUpLeft;
